import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const RoleList = ({ userObj: user, groupObj: group }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!user && !group) return;


    if (user) {
      rowsReq.query = 'USER_ROLE_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('userId', user.id));
    }

    if (group) {
      rowsReq.query = 'GROUP_ROLE_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('groupId', group.id));
    }

  }, [user, group])


  return (
    <EntityList
      entity="ROLE"
      augRowsReq={augRowsReq}
      augTabButtons={(buttons) => { ObjUtils.clearObj(buttons) }}
    />
  )
}